var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 7.3335V4.66683C3.66675 3.78277 4.01794 2.93493 4.64306 2.30981C5.26818 1.68469 6.11603 1.3335 7.00008 1.3335C7.88414 1.3335 8.73198 1.68469 9.3571 2.30981C9.98222 2.93493 10.3334 3.78277 10.3334 4.66683V7.3335M2.33333 7.3335H11.6667C12.403 7.3335 13 7.93045 13 8.66683V13.3335C13 14.0699 12.403 14.6668 11.6667 14.6668H2.33333C1.59695 14.6668 1 14.0699 1 13.3335V8.66683C1 7.93045 1.59695 7.3335 2.33333 7.3335Z",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.30fcba9449760b11309a6ced139a4235.svg";
export { ForwardRef as ReactComponent };